import React, { useEffect, useState } from "react";
import connect from "react-redux/es/connect/connect";
import {Redirect} from "react-router-dom";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Tooltip, Fab } from "@mui/material";

// @mui/icons-material
import { AddRounded } from "@mui/icons-material";

// core components
import Card from 'components/card/card';
import CardBody from 'components/card/cardBody';
import CardHeader from 'components/card/cardHeader';
import CreateDialog from './components/createDialog';
import GlobalAction from "./components/globalAction";
import GridContainer from 'components/grid/gridContainer';
import GridItem from 'components/grid/gridItem';
import ListLoader from '../configuration/components/listLoader';
import Notification from "./components/notification";
import Search from '../configuration/components/search';
import TableHead from '../configuration/components/tableHead';
import TableBody  from "./components/tableBody";

// styles
import listStyle from "assets/jss/views/configuration/defaultListStyle";

// actions
import { sectorList } from "actions/sector/list";

// utils
import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {withStyles} from "@mui/styles";

function List (props) {
    const {
        sectorList,
        classes,
        created,
        deleted,
        deletedSelection,
        loading,
        retrieved,
        updated,
    } = props;

    const [createDialog, showCreateDialog] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [search, setSearch] = useState('');
    const [checkedSectors, setCheckedSectors] = useState([]);

    useEffect(() => {
        sectorList("&pagination=false&order[name]=asc");
        setShowNotification(true);
    }, [created, deleted, updated, deletedSelection, sectorList]);

    if (false === hasAuthorization(props.authorizations, Authorizations.GLOBAL_ORGANIZATION_ESHOP_MANAGEMENT)) {
        return <Redirect to={'/'} />;
    }

    return (
        <div className={classes.containerWithSidebar}>
            <div className={classes.container}>
                <Notification isOpen={showNotification} closeNotification={() => setShowNotification(false)} />
                <GridContainer>
                    <GridItem xs={12}>
                        <Card className={classes.card}>
                            <CardHeader color="info">
                                <GridContainer>
                                    <GridItem xs={9} sm={10}>
                                        <h3>
                                            <FormattedMessage id={"sector.title"} />
                                        </h3>
                                    </GridItem>
                                    <GridItem xs={3} sm={2} className={classes.mainActionsContainer}>
                                        <Fab onClick={() => showCreateDialog(true)} color={"primary"}>
                                            <Tooltip title={<FormattedMessage id={"sector.add.sector"} />}>
                                                <AddRounded fontSize={"large"} />
                                            </Tooltip>
                                        </Fab>
                                    </GridItem>
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <div className={classes.subTableContainer}>
                                    {checkedSectors.length > 0 && (
                                        <GlobalAction sectors={checkedSectors} />
                                    )}
                                    <Search
                                        attributeName={"sector"}
                                        search={search}
                                        setSearch={setSearch}
                                    />
                                </div>
                                <div className={classes.spacer}></div>
                                <div className={classes.tableWrapper}>
                                    {!retrieved && <ListLoader loading={loading} />}
                                    <div>
                                        <TableHead
                                            listLoading={retrieved && (loading)}
                                            headers={[
                                                "sector.table.header.name",
                                                "sector.table.header.date",
                                            ]}
                                        />
                                        <TableBody
                                            retrieved={retrieved}
                                            search={search}
                                            checkedSectors={checkedSectors}
                                            setCheckedSectors={setCheckedSectors}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
            <CreateDialog closeDialog={() => showCreateDialog(false)} isOpen={createDialog} />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        retrieved: state.sector.list.retrieved,
        loading: state.sector.list.loading,
        created: state.sector.create.created,
        deleted: state.sector.deleteSector.deleted,
        updated: state.sector.update.updated,
        deletedSelection: state.sector.deleteSelection.deleted,
        authorizations: state.authentication.authorizations,
    };
};

const mapDispatchToProps = dispatch => ({
    sectorList: params => dispatch(sectorList(params)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(listStyle)(List));
